
<div v-if="!editing" class="hoveredit">
  <div class="d-flex justify-content-between">
    <b-form-checkbox
      v-if="!isTemplate"
      v-model="item.isCompleted"
      :value="true"
      :unchecked-value="false"
      @change="updateIsCompletedState($event)"
      :disabled="readOnly"
    >
      <div
        class="font-weight-bold ml-1 mb-0 cursor-pointer"
        :class="{ completed: item.isCompleted }"
        v-linkify-directive="item.title"
        @click="handleTitleClick"
      ></div>
    </b-form-checkbox>

    <div v-else class="font-weight-bold mb-0 cursor-pointer" @click="startEditItem">
      <i class="far fa-caret-right"></i>
      {{ item.title }}
    </div>

    <div class="d-flex flex-1">
      <div class="edit mr-2">
        <i
          class="displayonhover far fa-arrow-alt-up mr-2 cursor-pointer"
          v-if="itemIndex_ !== 1 && !readOnly"
          @click="changeSortOrder(-1)"
        ></i>
        <i
          class="displayonhover far fa-arrow-alt-down mr-2 cursor-pointer"
          v-if="itemIndex_ < itemcount"
          @click="changeSortOrder(+1)"
        ></i>
        <i class="far fa-pencil" v-if="!readOnly" @click="startEditItem()"></i>
      </div>

      <div class="">
        <i class="far fa-fw fa-info-circle" v-b-tooltip.hover="{ title: itemToolTip, html: true }"></i>
      </div>
    </div>
  </div>

  <div
    class="cl-item-body italic"
    v-linkify-directive="item.description"
    v-html="$options.filters.formatLineBreaks(item.description)"
  ></div>
</div>
<div v-else>
  <form class="edit-form" @submit.prevent="updateItem">
    <div class="label mt-1">Title</div>
    <input :disabled="!item.isEditable" type="text" ref="title" class="form-control form-control-sm" v-model="item.title" />

    <div class="label mt-2">Description / Outcome</div>
    <textarea-autosize rows="4" class="form-control form-control-sm" v-model="item.description" />

    <div class="d-flex justify-content-between mt-2 mb-2">
      <div>
        <button type="submit" class="btn btn-sm btn-success mr-2" style="width: 60px" :disabled="!item.title">
          <i class="far fa-save"></i>
          Save
        </button>
        <button class="btn btn-sm btn-info" style="width: 60px" @click="cancelEdit">Cancel</button>
      </div>

      <div @click="removeItem()" v-if="item.isEditable">
        <i class="far fa-trash-alt text-danger cursor-pointer"></i>
      </div>
    </div>
  </form>
</div>
